import React, { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { withStyles, Theme, MenuItem, ListItemText } from '@material-ui/core';
import { SeasonOptionsProps, SeasonOptionProps } from 'components/SelectOptions/type';
import CodeVO from 'commons/vo/CodeVO';

const StyledMenuItem = withStyles((theme: Theme) => ({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#D94F98',
      '& > *': {
        color: '#ffffff',
      },
    },
    '&:focus': {
      backgroundColor: '#D94F98',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

function Option({ season, isActive, onClick }: SeasonOptionProps) {
  const onClickItem = useCallback(() => {
    onClick(String(season.id));
  }, [onClick, season]);

  return (
    <StyledMenuItem onClick={onClickItem} selected={isActive}>
      <ListItemText>{season.name}</ListItemText>
    </StyledMenuItem>
  );
}

function SeasonOptions({ seasonId, seasonList, onClose, onChangeSeason }: SeasonOptionsProps) {
  const onClick = useCallback(
    (value: string) => {
      onChangeSeason(value);
      onClose();
    },
    [onChangeSeason],
  );

  const onClickAll = useCallback(
    () => {
      onChangeSeason('all');
      onClose();
    },
    [onChangeSeason],
  )

  return (
    <>
      <StyledMenuItem onClick={onClickAll} selected={seasonId === 'all'}>
        <ListItemText>모두</ListItemText>
      </StyledMenuItem>
      {seasonList.map((season: CodeVO) => (
        <Option isActive={seasonId === String(season.id)} onClick={onClick} season={season} />
      ))}
    </>
  );
}

export default SeasonOptions;
